import { Page } from '../../types'

const civilProsecutionsFraud: Page[] = [
    {
        pageType: 'question',
        title: 'Civil prosecutions for fraud',
        name: 'civil-prosecutions-fraud',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions were referred?',
                name: 'civil-prosecutions-fraud-referred',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions proceeded to charge?',
                name: 'civil-prosecutions-fraud-proceeded',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many prosecutions were successful?',
                name: 'civil-prosecutions-fraud-successful',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default civilProsecutionsFraud
